__turbopack_context__.v({
  "dropdownContent": "Dropdown-module__nIRqqW__dropdownContent",
  "dropdownMenu": "Dropdown-module__nIRqqW__dropdownMenu",
  "dropdownMenuItem": "Dropdown-module__nIRqqW__dropdownMenuItem",
  "dropdownMenuSeparator": "Dropdown-module__nIRqqW__dropdownMenuSeparator",
  "dropdownTriggerButton": "Dropdown-module__nIRqqW__dropdownTriggerButton",
  "scaleTransition": "Dropdown-module__nIRqqW__scaleTransition",
  "scaleTransitionOpen": "Dropdown-module__nIRqqW__scaleTransitionOpen",
});
